import { gql } from '@apollo/client';
import Fragments from './fragments';

export const PAGED_SCHEDULE_TYPE_CELL_PARAM_TEMPLATES_QUERY = gql`
  query pagedScheduleTypeCellParamTemplates($pager: PagerInputNew, $filters: ScheduleTypeCellParamTemplatesFilterInput) {
    pagedScheduleTypeCellParamTemplates(pager: $pager, filters: $filters) {
      total
      values {
        ...scheduleTypeCellParamTemplate
      }
    }
  }
  ${Fragments.scheduleTypeCellParamTemplate}
`;
